import React from "react";
import Box from "@mui/material/Box";
import { Typography, Button } from "antd";
import { Divider } from "@mui/material";
import "./logInPopup.css"
 
const LogInPopup = () => {
    return (
        <Box>
            <Box
                sx={{
                    width: "100%",
                    backgroundColor: "#FFFFFF",
                    border: "2px solid #EBEBEB",
                    borderRadius: "10px",
                }}
            >
                <Box className="newprofile-logout-main" sx={{
                    display: "flex", width: "100%", justifyContent: "space-around", marginTop: "20px"
                }}>
                    <Typography className="new-profile" sx={{ fontSize: "20px" }}>New Customer?</Typography>
                    <Divider orientation="vertical" flexItem sx={{ height: "20px", borderColor: "rgba(0, 0, 0, 0.2)", marginTop: "5px" }} />
 
                    <Button
                        className="logout-button"
                        type="text"
                        style={{
                            textDecoration: "underline",
                            color: "red",
                            cursor: "pointer",
                            marginTop:"-1%"
                        }}
                    >
                        Sign Up
                    </Button>
                </Box>
 
                <Box className="your-profile-main" sx={{ display: "flex", marginLeft: "12%", marginTop: "10%" }}>
                    <Box
                        component="img"
                        src="./image/Account.svg"
                        alt="Profile Image"
                        sx={{ width: "30px", height: "30px", borderRadius: "50%", margin: "1% 0 0 0" }}
                    />
                    <Typography className="your-profile">Your Profile</Typography>
                </Box>
                <Divider orientation="horizontal" flexItem sx={{ width: "320px", borderColor: "rgba(0, 0, 0, 0.5)", margin: "20px  30px" }} />
 
                <Box className="your-order-main" sx={{ display: "flex", marginLeft: "12%", marginTop: "10%" }}>
                    <Box
                        component="img"
                        src="./image/Basket icon.svg"
                        alt="Profile Image"
                        sx={{ width: "35px", height: "35px", margin: "0px 0 0 0" }}
                    />
                    <Typography className="your-profile">Your Orders/Enquiries</Typography>
 
                </Box>
                <Divider orientation="horizontal" flexItem sx={{ width: "320px", borderColor: "rgba(0, 0, 0, 0.5)", margin: "20px  30px" }} />
 
                <Box className="your-wishlist-main" sx={{ display: "flex", marginLeft: "12%", marginTop: "10%" }}>
                    <Box
                        component="img"
                        src="./image/wishlist-icon.svg"
                        alt="Profile Image"
                        sx={{ width: "35px", height: "35px", margin: "0px 0 0 0" }}
                    />
                    <Typography className="your-profile">Your Whishlist</Typography>
                </Box>
                <Divider orientation="horizontal" flexItem sx={{ width: "320px", borderColor: "rgba(0, 0, 0, 0.5)", margin: "20px  30px" }} />
 
 
                <Box className="your-giftcard-main" sx={{ display: "flex", marginLeft: "12%", marginTop: "10%" }}>
                    <Box
                        component="img"
                        src="./image/Gift-card.svg"
                        alt="Profile Image"
                        sx={{ width: "35px", height: "35px", margin: "0px 0 0 0" }}
                    />
                    <Typography className="your-profile">Your Gift Card</Typography>
                </Box>
                <Typography className="you-can-choose-login">You can choose the option to check the details. </Typography>
            </Box>
 
        </Box>
    );
};
 
export default LogInPopup;